export default "__VITE_ASSET__D5cOBGgp__"